import { useContext } from 'react';
import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

import SearchContext from './SearchContext';
import SearchField from './SearchField';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, breakpoints }) => ({
    root: {
      position: 'relative',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },

    label: {
      marginLeft: spacing(8),
    },

    content: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      height: '100%',
    },

    inputContainer: {
      height: '100%',
      marginLeft: spacing(8),
      marginRight: spacing(2),
      display: 'flex',
      alignItems: 'center',
    },

    [breakpoints.up('md')]: {
      inputContainer: {
        maxWidth: 704,
        marginLeft: '25%',
        marginRight: '25%',
      },
    },
  })
);

export default function SearchForm({ translations, isCompactMode = false, isFieldShown = false }) {
  const classes = useStyles();
  const { onQueryChange, hasEmptyPeopleList } = useContext(SearchContext);

  return (
    <form role="search" className={classes.root}>
      <Typography className={classes.label} component="label" variant="h5" htmlFor="people-search">
        {translations.inputSearchLabel}
      </Typography>

      {isFieldShown && !hasEmptyPeopleList && (
        <div className={classes.content}>
          <div className={classes.inputContainer}>
            <SearchField
              shouldAutoFocus
              onChange={onQueryChange}
              data-testid="people-search-input"
              id="people-search"
              translations={translations}
              hasSearchIconHidden={isCompactMode}
            />
          </div>
        </div>
      )}
    </form>
  );
}
